// The only markdown → HTML path in the app. Escape first, so only the tags this helper generates can reach the DOM.
export function escapeHtml(s) {
  return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

// Pipe tables (| a | b |, |---|---|, rows) → <table>. Runs on escaped text, so cells can't inject tags.
function tables(src) {
  return src.replace(/(?:^\|.*\|[ \t]*\n?){2,}/gm, (block) => {
    const rows = block.trim().split("\n").map((r) => r.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim()));
    if (rows.length < 2 || !rows[1].every((c) => /^:?-{2,}:?$/.test(c))) return block;
    const head = rows[0].map((c) => `<th>${c}</th>`).join("");
    const body = rows.slice(2).map((r) => `<tr>${r.map((c) => `<td>${c}</td>`).join("")}</tr>`).join("");
    return `<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>\n`;
  });
}

export function renderMarkdown(text) {
  return tables(escapeHtml(text))
    .replace(/^-{3,}$/gm, "<hr/>")
    .replace(/^### (.*)$/gm, "<h3>$1</h3>").replace(/^## (.*)$/gm, "<h2>$1</h2>").replace(/^# (.*)$/gm, "<h1>$1</h1>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*\w])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>")
    .replace(/^(?:- |\* )(.*)$/gm, "<li>$1</li>").replace(/(<li>.*<\/li>\n?)+/g, (m) => `<ul>${m}</ul>`)
    .replace(/^\d+\. (.*)$/gm, "<li>$1</li>")
    .replace(/\n{2,}/g, "<br/>");
}
